import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import cookies from 'js-cookie';
import { cookieNames } from '@monorepo/common';

interface AuthState {
  // Auth status
  isAuth: boolean;

  // Actions
  setAuth: (isAuth: boolean) => void;
  checkAuth: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      // Initial state
      isAuth: false,

      // Set auth status
      setAuth: (isAuth) => set({ isAuth }),

      // Check if user is authenticated based on cookie
      checkAuth: () => {
        const token = cookies.get(cookieNames.bevnet_token);
        set({ isAuth: !!token });
      },

      // Logout
      logout: () => {
        cookies.remove(cookieNames.bevnet_token);
        set({ isAuth: false });
      },
    }),
    {
      name: 'account-auth-storage',
      // Don't persist auth status - it should be determined by cookie
      partialize: () => ({}),
    }
  )
);
